import { useEffect, useState } from "react"
import { Card, CardModal, CardTitle } from "../../components/Card"
import { Button, ButtonLoader } from "../../components/Button"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel, ModalRemoveItem } from "../../components/Modal"
import { CheckBox, FormRow, Input, Label, SelectInput } from "../../components/Form"
import { LinkOrUpload } from "../../components/LinkOrUpload"
import { isValidURL } from "../../core/utils/validateFields"
import manejeCover from "../../assets/img/manejecover.png"
import listEmpty from "../../assets/img/list.png"
import clickOutSideHook from "../../core/utils/hooks/listen-click-outside"
import { DropDownOptionsWithButton } from "../../components/DropDownOptions"
import { HeaderContent } from "../../components/Header"
import { EmptyScreen } from "../../components/Empty"
import { FcLock } from "react-icons/fc";
import "./styles.scss"

function ReportsScreenDynamicDash({
  onChangeFile,
  modalTitle,
  reportList,
  openModalCard,
  openModalList,
  openModaEditlItemCard,
  openModalRemoveItem,
  modalIsOpen,
  closeModal,
  loading,
  newList,
  editList,
  handleSubmit,
  errors,
  register,
  watch,
  uploaded,
  uploadedImage,
  processingFile,
  isRemoveItem,
  onRemoveItem,
  currentUser,
  isSafeFile,
  setIsSafeFile,
  openFile,
  projectsByScope,
  selectedProject,
  control,
  setSelectedProject
}) {
  const { isActive, setIsActive, ref, resetState } = clickOutSideHook(false)
  const [visibility, setVisibility] = useState(null)

  const handleMenuOpen = (id) => {
    if (visibility === id) {
      setVisibility(null)
      setIsActive(false)
    } else {
      setVisibility(id)
      setIsActive(true)
    }
  }

  useEffect(() => {
    if (resetState) {
      setVisibility(null)
    }
  }, [resetState])

  const menuList = (reportListItem) => {
    return [{
      label: "Novo Item",
      onClick: () => openModalCard(reportListItem.id, reportListItem.name, true),
    },
    {
      label: "Editar Lista",
      onClick: (e) => openModalList(reportListItem.name, reportListItem.id, reportListItem?.isSafe, reportListItem?.project),
    },
    {
      label: "Excluir Lista",
      onClick: () => openModalRemoveItem(reportListItem.id, true),
    }]
  }

  const menuListItem = (item, reportListItem) => {
    return [
      {
        label: "Editar",
        onClick: () => openModaEditlItemCard(item, reportListItem.id),
      },
      { label: "Excluir", onClick: () => openModalRemoveItem(item.id) },
    ]
  }

  return (
    <div className="report-screen report-screen-new">
      <HeaderContent>
      <div className="new-report-list-button">
        <Button
          className="new-report-list__add"
          label="Nova lista"
          color="orange"
          handleClick={() => openModalList()}
        />
      </div>
      </HeaderContent>
      {reportList.length ? (
        reportList.map((reportListItem) => {
          return (
            <>
            <Card className="card-reports no-border">
              <div className="card-reports-header">
                { reportListItem?.isSafe === true ? (
                <div className="card-reports-title-security">
                  <FcLock size="30px" /> 
                  <CardTitle className="flex-start" title={reportListItem.name}/> 
                </div>
                ) : ( <CardTitle className="flex-start" title={reportListItem.name}/> )}             
                <DropDownOptionsWithButton
                  ref={ref}
                  handleMenuOpen={() => handleMenuOpen(reportListItem?.id)}
                  isActive={visibility === reportListItem?.id && isActive}
                  menuOptions={currentUser?.isAdmin ? menuList(reportListItem) : menuList(reportListItem).splice(0, 2)}
                />
              </div>
              <div className="card-reports-container">
                {reportListItem.reportListItem &&
                  reportListItem.reportListItem.map((item) => {
                    return (
                      <div className="card-reports__list">
                        <div
                          key={item?.id}
                          className="card-reports__list-item"
                          style={{
                            backgroundImage: `url(${item.image !== "" ? item.image : manejeCover})`,
                            cursor: item.link && "pointer",
                          }}
                        >
                        <div className="card-reports__list-item__content">
                          <div className="card-reports__list-item__content-action">
                            <DropDownOptionsWithButton
                              ref={ref}
                              handleMenuOpen={() => handleMenuOpen(item.id)}
                              isActive={visibility === item.id && isActive}
                              menuOptions={currentUser.isAdmin || currentUser?.userId === item.user?.id ?
                                menuListItem(item, reportListItem) :
                                menuListItem(item, reportListItem).splice(0, 1)
                              }
                            />
                          </div>
                          <div
                            className="card-reports__list-item__content-title"
                            onClick={() => item.link && openFile(item.link, reportListItem.id)}>
                            <h2>{item.name}</h2>
                          </div>
                        </div>
                      </div>
                    </div>
                    )
                  })}
              </div>
            </Card>
            </>
          )
        })
      ) : (
        <Card className="card-reports no-border">
          <EmptyScreen image={listEmpty} label="Não há listas para este projeto"/>
        </Card>
      )}
      {!isRemoveItem ? <ModalPanel width={!newList && !editList && 500} modalIsOpen={modalIsOpen}>
        <ModalHeader closeModal={() => closeModal()} title={modalTitle} />
        <ModalBody >
          <CardModal>
            <FormRow>
              <Label label="Titulo" />
              <Input
                placeholder={"Digite aqui o titulo"}
                register={register("title", {
                  required: { value: true, message: "Campo Obrigatório" },
                })}
                hasError={errors.title?.message}
              />
            </FormRow>
            <FormRow>
              <Label label="Projeto" />
              <SelectInput
                handleChange={(project) => setSelectedProject(project?.value)}
                defaultValue={selectedProject}
                closeMenuOnSelect
                isSearchable
                isClearable
                name="projects"
                options={projectsByScope && projectsByScope.map(row => ({ value: row.id, label: row?.description }))}
                control={control}
              />
            </FormRow>
            <FormRow>
              {(newList || editList) && 
                <div style={{display: "flex", alignItems: "center"}}>
                  <CheckBox
                    label="Manter os arquivos seguros"
                    onChange={() => setIsSafeFile(!isSafeFile)}
                    value={'isSafeFile'}
                    checked={isSafeFile}
                    disabled={editList} 
                  />
                  <FcLock size="15px" style={{marginLeft: "5px"}}/>
                </div>
              }
            </FormRow>
            {!newList && !editList && (
              <>
                <div className="card-reports-cover">
                  <LinkOrUpload
                    labelInput="Link do Arquivo"
                    placeholderInput="Digite aqui o link do arquivo"
                    labelButton={uploaded ? "Editar Arquivo" : "Upload Arquivo"}
                    name="linkFile"
                    register={register}
                    handleFileChange={(e) => onChangeFile(e, true)}
                    errors={errors.linkFile?.message}
                    nameFile="file"
                    required={{
                      required: !uploaded &&
                        !watch("linkFile")?.length && {
                        value: true,
                        message: "Campo link ou upload de arquivo obrigatórios",
                      },
                      validate: (value) =>
                        isValidURL(value) || "Url Inválida. Ex: https://www.manejebem.com",
                    }}
                  />
                </div>
                <div className="card-reports-cover">
                  <LinkOrUpload
                    labelInput="Link da Capa"
                    placeholderInput="Digite aqui o link da Capa"
                    labelButton={uploadedImage ? "Editar Capa" : "Upload Capa"}
                    name="linkCover"
                    register={register}
                    handleFileChange={onChangeFile}
                    errors={errors.linkCover?.message}
                    acceptFile="image/png"
                    nameFile="picture"
                    required={{
                      validate: (value) =>
                        isValidURL(value) || "Url Inválida. Ex: https://www.manejebem.com",
                    }}
                  />
                </div>
              </>
            )}
          </CardModal>
        </ModalBody>
        <ModalFooter>
          <ButtonLoader
            loading={loading || processingFile}
            messageProcess={processingFile ? "Aguarde, fazendo upload..." : "Salvando"}
            label={"Salvar"}
            color="orange"
            handleClick={handleSubmit}
          />
        </ModalFooter>
      </ModalPanel> : <ModalRemoveItem {...{ modalIsOpen, closeModal, loading }} modalTitle="Excluir Item" handleClick={() => onRemoveItem()} />}
    </div>
  )
}

export default ReportsScreenDynamicDash
